import React from 'react';
import { RequiredInfoText } from '../../components/Form';
import Typo3Label from '../../provider/Typo3Provider/Typo3Label';

const RequiredInfo = () => (
  <RequiredInfoText>
    <Typo3Label label="form.required.text">
      Bitte füllen Sie die gekennzeichneten Felder aus (Pflichtfelder)
    </Typo3Label>
  </RequiredInfoText>
);

export default RequiredInfo;
